import { TemplateApiUrls } from "@/modules/template/common/enum";
import type {
  IBudgetTransferTemplate,
  ICreateBudgetTransferTemplateRequest,
  IUpdateBudgetTransferTemplateRequest,
} from "@/modules/template/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const budgetTransferTemplateApi = createApi({
  reducerPath: "budgetTransferTemplateApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getBudgetTransferTemplate: builder.query<IBudgetTransferTemplate, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${TemplateApiUrls.BudgetTransferTemplateV2}/${id}`,
      }),
      keepUnusedDataFor: 0,
    }),
    createBudgetTransferTemplate: builder.mutation<string, ICreateBudgetTransferTemplateRequest>(
      withIdempotency<ICreateBudgetTransferTemplateRequest>(
        TemplateApiUrls.BudgetTransferTemplateV2
      )),
    updateBudgetTransferTemplate: builder.mutation<string, IUpdateBudgetTransferTemplateRequest>({
      query: ({ data, id }) => ({
        url: `${TemplateApiUrls.BudgetTransferTemplateV2}/${id}`,
        method: "PUT",
        data,
      }),
    }),
  }),
});

export const {
  useGetBudgetTransferTemplateQuery,
  useCreateBudgetTransferTemplateMutation,
  useUpdateBudgetTransferTemplateMutation,
} = budgetTransferTemplateApi;
